export const LOW_STOCK_DISMISS_KEY = 'lowStockAlertDismissedAt';

export const resetLowStockAlertDismissal = () => {
  sessionStorage.removeItem(LOW_STOCK_DISMISS_KEY);
};
